module.exports = __webpack_public_path__ + "static/media/cp8in.72785c7c.png";